import React from 'react';
import {Field} from 'redux-form';
import DateMMYYRedux from "./ReduxComponent/DateMMYY";

const Date3 = (props) => {
    return (
        <div className={props.itemCols}>
            <Field component={DateMMYYRedux} {...props} />
        </div>
    );
};

export default Date3;